export const TOKEN_STORE = 'cont-token';
export const USER_LANG_STORE = 'cont-lang';
